// 관리자 인증 흐름 API 호출.
// /admin/auth/login           : login_id + password 검증 → 액세스 + 리프레시 + admin + changePasswordRequired
// /admin/auth/me              : 본인 정보 (require admin)
// /admin/auth/logout          : 단일 디바이스 리프레시 토큰 무효화
// /admin/auth/change-password : 비밀번호 변경 + 모든 디바이스 강제 로그아웃

import { api } from "@/api/client.ts";
import type { AdminUser } from "@/stores/adminAuthStore.ts";

export interface AdminLoginResponse {
  ok: true;
  accessToken: string;
  expiresAtSec: number;
  refreshToken: string;
  refreshExpiresAt: string;
  admin: AdminUser;
  changePasswordRequired: boolean;
}

// 관리자 로그인.
// 본 함수는 토큰을 store 에 직접 저장하지 않는다 - 호출자가 응답을 받아 setSession 한다 (테스트 용이성).
export function loginAdmin(loginId: string, password: string): Promise<AdminLoginResponse> {
  return api.post<AdminLoginResponse>(
    "/admin/auth/login",
    { loginId, password },
    { withAuth: false },
  );
}

// 본인 정보 + 비밀번호 변경 필요 여부.
export interface AdminMeResponse {
  ok: true;
  admin: AdminUser;
  changePasswordRequired: boolean;
}

// 라우트 가드/대시보드 진입 시 호출해 server 측 최신 상태(must_change_password 변동 등) 와 동기화한다.
export function fetchAdminMe(): Promise<AdminMeResponse> {
  return api.get<AdminMeResponse>("/admin/auth/me");
}

// 단일 디바이스 로그아웃 - 서버는 해당 리프레시 토큰만 폐기한다.
export function logoutAdmin(refreshToken: string): Promise<{ ok: true }> {
  return api.post<{ ok: true }>("/admin/auth/logout", { refreshToken }, { withAuth: false });
}

// 비밀번호 변경. 성공 시 서버는 모든 활성 리프레시 토큰을 일괄 폐기한다 - 호출자는 store 도 비우고 로그인 화면으로 보낸다.
export function changeAdminPassword(
  currentPassword: string,
  newPassword: string,
): Promise<{ ok: true }> {
  return api.post<{ ok: true }>("/admin/auth/change-password", { currentPassword, newPassword });
}
